import { useEffect } from 'react';
import { useUserStore } from 'src/store/user-store';
import { useGenerateSiteSearchKey } from './use-generate-site-search-key';
import { useGenerateTenantSearchKey } from './use-generate-tenant-search-key';

export const useMeilisearchApiKey = (enabled: boolean = true) => {
  const meilisearchToken = useUserStore(state => state.meilisearchToken);
  const setMeilisearchToken = useUserStore(state => state.setMeilisearchToken);
  const viewContext = useUserStore(state => state.viewContext);
  const setIsChangingDirectory = useUserStore(
    state => state.setIsChangingDirectory,
  );

  const { data: newMeilisearchTenantToken } = useGenerateTenantSearchKey(
    viewContext === 'tenant' && enabled,
  );

  const { data: newMeilisearchSiteToken } = useGenerateSiteSearchKey(
    viewContext === 'site' && enabled,
  );

  useEffect(() => {
    if (viewContext === 'tenant') {
      if (
        newMeilisearchTenantToken &&
        newMeilisearchTenantToken !== meilisearchToken
      ) {
        setMeilisearchToken(newMeilisearchTenantToken);
        setIsChangingDirectory(false);
      }
    } else if (viewContext === 'site') {
      if (
        newMeilisearchSiteToken &&
        newMeilisearchSiteToken !== meilisearchToken
      ) {
        setMeilisearchToken(newMeilisearchSiteToken);
        setIsChangingDirectory(false);
      }
    }
  }, [
    meilisearchToken,
    newMeilisearchSiteToken,
    newMeilisearchTenantToken,
    setIsChangingDirectory,
    setMeilisearchToken,
    viewContext,
  ]);
};
